export enum CardOptionType {
  NOT_SELECTED,
  PRINTIBLE,
  CARD_MESSAGE,
}
